import { Button, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PageContainer from "../../components/PageContainer";
import logo from '../../assets/logo.png';

import { useStyles } from './styles'

function Welcome() {
  const [isLoaded, setIsLoaded] = useState(false);
  const classes = useStyles()
  let history = useHistory();

  function handleNext() {
    history.replace('/home')
  }

  useEffect(() => {
    if (localStorage.getItem("firstTime")) {
      return history.replace('/home')
    } 
    localStorage.setItem('firstTime', true)
    setIsLoaded(true);
  }, [])

  return (
    <>
      {isLoaded && (
        <PageContainer>
          <div className={classes.wrapper}>
            <img src={logo} alt="logo" />
            <Typography variant="h1">
            Bem-vindo(a),
            </Typography>
            <Typography className={classes.description}>
              Neste aplicativo você tem acesso a 
              <span> Serviços </span> 
              e 
              <span> Legislação </span> 
              voltados para a pessoa idosa.
            </Typography>
            <Button 
              variant="contained" 
              className={classes.button}
              onClick={() => handleNext()}
            >
              Próximo
            </Button>
          </div>
        </PageContainer>
      )}     
    </>
  );
}

export default Welcome